import { lazy } from "react";
import { Navigate } from "react-router-dom";
const LoginPage = lazy(() => import("modules/auth/LoginPage"));
const MainLayout = lazy(() => import("modules/dashboard/MainLayout"));
const POSPage = lazy(() => import("modules/dashboard/POSPage"));
const BillsPage = lazy(() => import("modules/dashboard/BillsPage"));
const InvoiceViewPage = lazy(() => import("modules/dashboard/InvoiceViewPage"));
const CheckAuth = (isUserLoggedIn: boolean, component: any) => {
  if (isUserLoggedIn) {
    return component;
  }
  return <Navigate to="/login" />;
};
const routes = (isUserLoggedIn: boolean): any => [
  {
    path: "/",
    element: CheckAuth(isUserLoggedIn, <MainLayout />),
    children: [
      { path: "new-bill", element: <POSPage /> },
      { path: "bills", element: <BillsPage /> },
      { path: "invoice/:invoiceId", element: <InvoiceViewPage /> },
    ],
  },
  { path: "/login", element: <LoginPage /> },
  { path: "*", element: <Navigate to="/login" /> },
];

export default routes;
